import { combineReducers, AnyAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { AppState } from '../Store'

import businessJoin from './business/join'
import businessInfo from './business/info'
import businessMember from './business/member'
import businessPayment from './business/payment'
import businessMembership from './business/membership'
import businessUsageHistory from './business/usage'
import businessSettlement from './business/settlement'
import modal from './modal'
import userInfo from './user/info'
import userMembership from './user/membership'
import userInquiry from './user/inquiry'
import userHistory from './user/history'
import unique from './s/unique'
import commons from './commons'

const rootReducer = combineReducers({
  businessJoin,
  businessInfo,
  businessMember,
  businessPayment,
  businessMembership,
  businessUsageHistory,
  businessSettlement,
  modal,
  userInfo,
  userMembership,
  userHistory,
  userInquiry,
  unique,
  commons,
})

export const reducer = (state: AppState, action: AnyAction) => {
  if (action.type === HYDRATE) {
    return {
      ...state,
      ...action.payload,
    }
  }
  return rootReducer(state, action)
}

export default rootReducer

export type RootState = ReturnType<typeof rootReducer>
